import ContentLoader from '@space-core/components/contentLoader'
import { useThemeContext, useMediaQuery } from '@space-core/hooks'
import { ScreenSizes } from '@space-core/styles'
import { LanguageUtils } from '@space-core/utils/language'

import { IdleRenderer } from '@space-shell/common/components/idleRenderer'
import { useTranslation } from 'react-i18next'

import { AuthenticatedHeader } from './authenticatedHeader'
import { UnauthenticatedHeader } from './unauthenticatedHeader'
import { useAuthState } from './useAuthState'
import { useHeaderDropdownItems } from './useHeaderDropdownItems'
import { useHeaderEventHandlers } from './useHeaderEventHandlers'
import { useHeaderExperiments } from './useHeaderExperiments'

export default function MainHeaderBar() {
  const { i18n } = useTranslation()
  const { theme, switchTheme } = useThemeContext()
  const isMobile = useMediaQuery(`(max-width: ${ScreenSizes.lg})`)
  const applicationLanguage = LanguageUtils.formatLanguage(i18n.language).toLowerCase()
  const authState = useAuthState()
  const experiments = useHeaderExperiments()
  const handlers = useHeaderEventHandlers()
  const { publicItems, privateItems } = useHeaderDropdownItems(handlers)

  if (authState.isAuthenticating) {
    return (
      <ContentLoader dataTest='content-loader' slot='actions-end' className='_w-12 _h-5 _rounded' />
    )
  }

  if (authState.shouldShowUnauthenticatedHeader) {
    return (
      <UnauthenticatedHeader
        handleLanguageChange={handlers.handleLanguageChange}
        handleRedirectToSignIn={handlers.handleSignIn}
        isMobile={isMobile}
        publicItems={publicItems}
        theme={theme}
        switchTheme={switchTheme}
        applicationLanguage={applicationLanguage}
      />
    )
  }

  return (
    <IdleRenderer
      extraDelay={2000}
      minIdleTime={10}
      requiredIdleFrames={3}
      loadingElement={<ContentLoader slot='actions-end' className='_w-12 _h-5 _rounded' />}>
      <AuthenticatedHeader
        {...experiments}
        handleLanguageChange={handlers.handleLanguageChange}
        userName={authState.userName}
        applicationLanguage={applicationLanguage}
        privateItems={privateItems}
        switchTheme={switchTheme}
        theme={theme}
      />
    </IdleRenderer>
  )
}
